<template>
  <div class="home">
    <Header />
    <router-view />
    <Footer />
  </div>
</template>

<script>
import Header from '@/views/pc/common/header'
import Footer from '@/views/pc/common/footer'
export default {
  name: 'pc-home',
  components: {
    Header,
    Footer
  }
}
</script>